<div class="container">
  <h2> Patient Registration Form </h2>
  
  <form #patientRegisterForm="ngForm" (ngSubmit)="onSubmit(patientRegisterForm)">
        <fieldset>
          <legend class="mb-0">Personal Information</legend>
          <div class='row'>
              
              <div class='col-sm-3'>
                  <div class='form-group'>
                      <label class="mb-0"for="user_firstname">First Name</label>                      
                      <input type="text"  class="form-control" name="firtName" size="20"
                      placeholder="First Name" 
                      [(ngModel)]="patient.firstName" required minlength="2"  #firstNameField="ngModel">
                     <!-- <div size=2 class="mt-0 errorField" [hidden]="firstNameField.valid|| firstNameField.untouched" class="alert alert-danger">
                        Please enter a valid first name.
                       </div>-->
                  </div>
              </div>
              <div class='col-sm-3'>
                  <div class='form-group'>
                      <label class="mb-0"for="user_lastname">Last Name</label>
                      <input class="form-control" type="text" name="lastName" size="20" placeholder="Last Name" 
                      [(ngModel)]="patient.lastName" required min="2">
                  </div>
              </div>

              <div class='col-sm-2'>    
                <div class='form-group'>
                    <label class="mb-0"for="user_gender">Gender</label>
                    <select class="form-control" name="gender" id="GenderSelect" [(ngModel)]="patient.gender" required>
                      <option class="ml-0" value="">Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>      
                  </select>         
                </div>
            </div>

              <div class='col-sm-2'>
                <div class='form-group'>    
                    <label class="mb-0"for="dob">DOB</label>
                    <input type="date" id="dob" data-date-format="MM-dd-yyyy" size="20" name="dob" class="form-control" placeholder="DOB"  [(ngModel)]="patient.dob" required>                    
                </div>
            </div>

            <div class='col-sm-2'>
              <div class='form-group'>    
                  <label class="mb-0"for="SSN">SSN</label>
                  <input type="text" name="ssn" class="form-control" size="30" placeholder="SSN"  [(ngModel)]="patient.ssn" required>
              </div>
          </div>

          </div>
         
      </fieldset>

      <fieldset>
        <legend class="mb-0">Address</legend>
        <div class='row'>
            
            <div class='col-sm-3'>
                <div class='form-group'>
                    <label class="mb-0"for="addressFirstLine">Address First Line</label>
                    <input type="text" id= "addressFirstLine" name="addressFirstLine"  class="form-control" placeholder="Address First Line" required
                    [(ngModel)]="patient.address.firstLine">
                </div>
            </div>
            <div class='col-sm-3'>
                <div class='form-group'>
                    <label class="mb-0"for="addressSecondLine">Address Second Line</label>
                    <input class="form-control" id="addressSecondLine" type="text" name="addressSecondLine" size="30" placeholder="Address Second Line" 
                    [(ngModel)]="patient.address.secondLine" required min="2">
                </div>
            </div>

            <div class='col-sm-2'>    
              <div class='form-group'>
                  <label class="mb-0"for="city">City</label>
                  <input type="text" id="city" name="city"class="form-control" placeholder="City" size="20" required
          [(ngModel)]="patient.address.city">
              </div>
          </div>

            <div class='col-sm-2'>
              <div class='form-group'>    
                  <label class="mb-0"for="zip">Zip</label>
                  <input type="text" id="zip" name="zip"class="form-control" size="20" placeholder="Zip"  
            [(ngModel)]="patient.address.zip">
              </div>
          </div>

          <div class='col-sm-2'>
            <div class='form-group'>    
                <label class="mb-0"for="state">State</label>
                <input type="text" id="state" name="state" class="form-control" placeholder="State"  required
                [(ngModel)]="patient.address.state">
            </div>
        </div>

        </div>
       
    </fieldset>


    <fieldset>
      <legend class="mb-0">Contact</legend>
      <div class='row'>
          
          <div class='col-sm-3'>
              <div class='form-group'>
                  <label class="mb-0 small" for="email">Email</label>
                  <input type="email" id= "email" name="email"  class="form-control" placeholder="Email" required
                  [(ngModel)]="patient.contact.email">
              </div>
          </div>
          <div class='col-sm-3'>
              <div class='form-group'>
                  <label class="mb-0" for="phoneType">Phone Type</label>
                  <select class="form-control" id="phoneType" name="phoneType" id="phoneSelect" [(ngModel)]="patient.contact.phones[0].phoneType">
                    <option class="ml-0" value="">Select Phone Type</option>
                  <option>Mobile</option>
                  <option>Home</option>
                  <option>Office</option>             
                </select> 
              </div>
          </div>

          <div class='col-sm-3'>    
            <div class='form-group'>
                <label class="mb-0" for="phoneNumber">Phone Number</label>
                <input type="text" name="phoneNumber" id="phoneNumber" class="form-control" placeholder="Phone Number" [(ngModel)]="patient.contact.phones[0].number">
            </div>
        </div>

          <div class='col-sm-3'>
            <div class='form-group'>    
                <label class="mb-0" for="zip">Office Id(Temp)</label>
                <input type="number" name="officeId" class="form-control" placeholder="Office Id" [(ngModel)]="patient.office.id">
            </div>
        </div>

        

      </div>
     
  </fieldset>

     
  <div class="container">   
    <div class="row">  
      <div id ="btn-success"class="ml-0 pl-0 col-sm-3">
        <button class="btn  btn-success">Submit</button>        
      </div>      
      <div id ="errorDiv" class="col-sm-9 alert border border-danger alert-danger text-capitalize" [hidden]="!postError">     
         <ul class="heroes">
           <li *ngIf='errorMessage'>  {{errorMessage}}</li>
           <li *ngIf='unhandledError'>   {{unhandledError}}</li>
           <li *ngFor='let err of errorResponse?.errors'>
            <span class="badge">{{err}}</span> 
             </li>          
          </ul>         
      </div>
      <div id ="errorSuccess" class="col-sm-9  border border-success alert alert-success" [hidden]="!postSuccess">     
         Patient registered successfully. 
     </div>
    </div>
  </div>  

      
    
     
  </form>

</div>
